// extracted by mini-css-extract-plugin
export default {"e_nodata_wrapper":"nodata_e_nodata_wrapper__SltBe","e_img":"nodata_e_img__ynRkQ","e_title":"nodata_e_title__b3aFK","e_note":"nodata_e_note__Zq1mA"};